import { getSign } from '@didi/wsgsig'
function getContentType(headers, method = 'post') {
    console.log('headers',headers)
    // 如果没有 method-specific headers，检查通用 headers
    if (headers['Content-Type']) {
        return headers['Content-Type'];
      }
    // 检查是否存在 method-specific headers
    if (headers[method] && headers[method]['Content-Type']) {
      return headers[method]['Content-Type'];
    }
    return false // 默认值
  }
const setSign  = function(axiosConfig){
    // debugger
    const  {params,data,headers,method} = axiosConfig
    const tsObj = {
        ts:new Date().getTime()
    }
    let signObj = {}
    let dataSign = null
    let paramsSign = null
    if(params){
        paramsSign = {params}
    }
    if(data){
        let contentType = getContentType(headers,method);
        if(contentType && (contentType.indexOf('application/json') >= 0 || contentType.indexOf('application/x-www-form-urlencoded') >= 0)){
            dataSign = Object.assign({},{
                body:data,
                contentType
            })
        }
    }
    if(dataSign  === null && paramsSign === null){
        signObj = {
            params:tsObj
        }
    }else{
        if(params){
            signObj = Object.assign({},paramsSign)
        }
        if(data){
            signObj=Object.assign({},signObj,dataSign)
        }
    }
    console.log('signObj',signObj)
    let ngis = getSign(signObj);
    console.log('ngis',ngis)
    if(!axiosConfig.params){
        axiosConfig.params = {}
    }
    
    axiosConfig.params[String.fromCharCode(119, 115, 103, 115, 105, 103)] = ngis;
    return axiosConfig
}
const getSignWithts = function(){
    let ngis = getSign({
        params:{
            ts:new Date().getTime()
        }
    });
    return `wsgsig=${encodeURIComponent(ngis)}`
}
export { setSign, getSignWithts };